import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import { post } from 'api';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import * as yup from 'yup';

const folloupSchema = yup.object({
  description: yup.string().required('description is required'),
  date: yup
    .date()
    .transform((value, originalValue) => (originalValue ? new Date(originalValue) : null))
    .typeError('Invalid date')
    .min(new Date(), 'Cannot select future dates'),
});

export default function FollowupCreate({ open, setOpen, enquiry, fetchData }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(folloupSchema),
    defaultValues: {
      date: new Date(),
      description: '',
    },
  });

  const onClose = () => {
    reset();
    setOpen(false);
    fetchData();
  };

  const submitStock = async (data) => {
    try {
      const res = await post('users/create_followup', {
        ...data,
        enquiryId: enquiry._id,
        status: false,
      });

      if (res.status == 200) {
        enqueueSnackbar(res.message || 'Followup Created Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(res.message || 'Error While Creating Followup', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error While Creating Followup', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      component="form"
      onSubmit={handleSubmit(submitStock)}
    >
      {/* HEADER */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 1 }}>
        <DialogTitle sx={{ fontSize: 20, fontWeight: 700 }}>Create Enquiry</DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {/* BODY */}
      <DialogContent sx={{ px: 2 }}>
        {/* VENDOR */}
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              name="date"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Date"
                  type="date"
                  variant="filled"
                  fullWidth
                  // InputLabelProps={{ shrink: true }}
                  error={!!errors.date}
                  helperText={errors.date?.message}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                    htmlInput: {
                      min: moment().format('YYYY-MM-DD'), // 👉 disables future dates in calendar
                      // onInvalid: (e) => e.preventDefault(), // ❗ blocks browser tooltip
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <TextField
                  {...field}
                  multiline
                  rows={3}
                  fullWidth
                  label="Description"
                  error={!!errors.description}
                  helperText={errors.description?.message}
                  slotProps={{ htmlInput: { maxLength: 200 } }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" type="submit">
          Creat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
